import { Link } from "react-router-dom";
import HomeLayout from "../../commonComponents/HomeLayout";

const HowItWorks = () => {
  return (
    <HomeLayout>
      <section className="px-6 sm:px-10 lg:px-[65px] pt-[30px] lg:max-w-[1300px] mx-auto">
        <div className="grid grid-cols-1 gap-10">
          <div className="bg-primary text-white px-4 pt-5 pb-10 text-center">
            <h2 className="text-[28px] font-medium">How It Works</h2>
            <p className="mt-6 font text-[20px]">
              Your complete guide to purchasing property through Home & Abroad.{" "}
              <br />
              Follow these simple steps to turn your dream home into reality.
            </p>
          </div>
          <div className="border rounded-lg py-11 px-6 sm:pr-[42px] sm:pl-[45px] flex flex-col sm:flex-row gap-x-4">
            <div className="shrink-0">
              <img
                className="sm:h-[86px] aspect-square"
                src="/assets/images/home-search.png"
                alt=""
              />
            </div>
            <div>
              <h4 className="text-primary font-medium text-[28px]">
                Find Your Dream Property
              </h4>
              <p className="my-2 text-[20px]">
                Choose from a wide range of houses available on the home and
                abroad platform. View property pictures, request a virtual or
                Live property tour, and if you love the property, Simply fill
                out a property purchase form.​
              </p>
              <div className="mt-2 grid sm:grid-cols-2 text-[#333333] gap-y-3 gap-x-6">
                <div className="p-6 sm:pr-[20px] bg-primary/[8%] rounded-2xl">
                  <div className="flex items-center gap-x-[15px]">
                    <img
                      src="/assets/images/search-terms.png"
                      className="h-[25px] aspect-square"
                      alt=""
                    />
                    <p className="text-[22px] font-medium">
                      Find Your Dream Property
                    </p>
                  </div>
                  <p className="text-[18px] mt-2">
                    Use filters for location, price, property type, and
                    amenities to find exactly what you’re looking for.
                  </p>
                </div>
                <div className="p-6 sm:pr-[20px] bg-primary/[8%] rounded-2xl">
                  <div className="flex items-center gap-x-[15px]">
                    <img
                      src="/assets/images/video-icon-terms.png"
                      className="shrink-0 h-[17px] w-[28px]"
                      alt=""
                    />
                    <p className="text-[22px] font-medium">Virtual Tours</p>
                  </div>
                  <p className="text-[18px] mt-2">
                    Request live or virtual tours to explore properties from the
                    comfort of your home.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="border rounded-lg py-11 px-6 sm:pr-[42px] sm:pl-[45px] flex flex-col sm:flex-row gap-x-4">
            <div className="shrink-0">
              <img
                className="h-[40px] sm:h-[86px]"
                src="/assets/images/purchase-form.png"
                alt=""
              />
            </div>
            <div>
              <h4 className="text-primary font-medium text-[28px]">
                Fill The Property Purchase Form
              </h4>
              <p className="mt-2 text-[20px]">
                Click on “Buy Property”, fill out the property purchase form
                with the important details, and an automated Invoice will be
                displayed and also sent to your email address.
              </p>
              <div className="mt-4 p-6 bg-[#CECECE]/[15%] rounded-2xl">
                <p className="text-[22px] font-medium">Required Information</p>
                <div className="mt-5 grid gap-y-3">
                  <div className="flex items-center gap-x-5">
                    <img src="/assets/images/check-circle.svg" alt="" />
                    <span className="body-description">
                      Personal details and contact information
                    </span>
                  </div>
                  <div className="flex items-center gap-x-5">
                    <img src="/assets/images/check-circle.svg" alt="" />
                    <span className="body-description">
                      Buyer type and ownership preference
                    </span>
                  </div>
                  <div className="flex items-center gap-x-5">
                    <img src="/assets/images/check-circle.svg" alt="" />
                    <span className="body-description">
                      ID verification documents
                    </span>
                  </div>
                  <div className="flex items-center gap-x-5">
                    <img src="/assets/images/check-circle.svg" alt="" />
                    <span className="body-description">
                      Payment method selection
                    </span>
                  </div>
                </div>
              </div>
              <div className="mt-4 flex items-center gap-x-4 bg-primary/5 p-4 rounded-2xl">
                <img src="/assets/images/clock.png" alt="" />
                <span className="text-[16px] text-primary">
                  You’ll receive an invoice and confirmation email immediately
                  after form submission.
                </span>
              </div>
            </div>
          </div>
          <div className="border rounded-lg py-11 px-6 sm:pr-[42px] sm:pl-[45px] flex flex-col sm:flex-row gap-x-4">
            <div className="shrink-0">
              <img
                className="h-[40px] sm:h-[86px] aspect-square"
                src="/assets/images/home-search.png"
                alt=""
              />
            </div>
            <div>
              <h4 className="text-primary font-medium text-[28px]">
                Make Payment
              </h4>
              <p className="mt-2 text-[20px]">
                Make a payment for the property using the payment channel on the platform
              </p>
              <div className="mt-4 flex flex-col gap-y-3 sm:flex-row gap-x-[15px] text-[18px]">
                <div className="border border-[#CECECE] rounded w-full sm:w-[185px] flex flex-col gap-y-2 items-center pt-4 pb-[14px]">
                  <img src="/assets/images/firstbank.png" alt="" />
                  <span>First Bank</span>
                </div>
              </div>
              <div className="mt-4 flex items-center gap-x-4 bg-primary/5 p-4 rounded-2xl">
                <img src="/assets/images/clock.png" alt="" />
                <span className="text-[16px] text-primary">
                  New customers may need to open a secure property purchase account for property purchase.
                </span>
              </div>
            </div>
          </div>
          <div className="border rounded-lg py-11 px-6 sm:pr-[42px] sm:pl-[45px] flex flex-col sm:flex-row gap-x-4">
            <div className="shrink-0">
              <img
                className="h-[40px] sm:h-[86px] aspect-square"
                src="/assets/images/home-search.png"
                alt=""
              />
            </div>
            <div>
              <h4 className="text-primary font-medium text-[28px]">
                Get Your Sale Receipt
              </h4>
              <p className="mt-2 text-[20px]">
                Once Payment is confirmed, a sales receipt is generated for the
                purchased property from the Home and Abroad Platform. This
                receipt can be downloaded from your mail or from the Home and
                Abroad Platform.​
              </p>
              <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 text-[#333333] gap-x-6 gap-y-4">
                <div className="p-6 sm:pr-[20px] bg-primary/[8%] rounded-2xl">
                  <div className="flex items-center gap-x-[15px]">
                    <img
                      src="/assets/images/email-terms.png"
                      className="w-[25px] h-5"
                      alt=""
                    />
                    <p className="text-[22px] font-medium">Email Delivery</p>
                  </div>
                  <p className="text-[18px] mt-2">
                    Receipt sent instantly to your registered email address
                  </p>
                </div>
                <div className="p-6 sm:pr-[20px] bg-primary/[8%] rounded-2xl">
                  <div className="flex items-center gap-x-[15px]">
                    <img
                      src="/assets/images/dashboard-terms.png"
                      className="shrink-0 h-[25px] w-[28px]"
                      alt=""
                    />
                    <p className="text-[22px] font-medium">Dashboard Access</p>
                  </div>
                  <p className="text-[18px] mt-2">
                    View and download from your user dashboard anytime.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="border rounded-lg py-11 px-6 sm:pr-[42px] sm:pl-[45px] flex flex-col sm:flex-row gap-x-4">
            <div className="shrink-0">
              <img
                className="h-[40px] sm:h-[86px]"
                src="/assets/images/property-key.png"
                alt=""
              />
            </div>
            <div>
              <h4 className="text-primary font-medium text-[28px]">
                Fill The Property Purchase Form
              </h4>
              <p className="mt-2 text-[20px]">
                Finally, your property document and Keys will be sent to you
                anywhere in the world through our Logistics partners DHL or
                picked up from the seller by a representative of yours. You now
                own a home back home​
              </p>
              <div className="mt-4 ">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4 mt-5">
                  <div className="p-6 bg-[#CECECE]/[15%] rounded-2xl">
                    <p className="text-[22px] font-medium">
                      Documentation Package
                    </p>
                    <div className="grid gap-y-3 mt-5">
                      <div className="flex items-center gap-x-5">
                        <img src="/assets/images/check-circle.svg" alt="" />
                        <span className="body-description">
                          Property Developer Sales Receipt
                        </span>
                      </div>
                      <div className="flex items-center gap-x-5">
                        <img src="/assets/images/check-circle.svg" alt="" />
                        <span className="body-description">
                          Letter of Allotment (Houses)
                        </span>
                      </div>
                      <div className="flex items-center gap-x-5">
                        <img src="/assets/images/check-circle.svg" alt="" />
                        <span className="body-description">
                          Letter of Allocation (Land)
                        </span>
                      </div>
                      <div className="flex items-center gap-x-5">
                        <img src="/assets/images/check-circle.svg" alt="" />
                        <span className="body-description">
                          Deed of Assignment (Houses)
                        </span>
                      </div>
                      <div className="flex items-center gap-x-5">
                        <img src="/assets/images/check-circle.svg" alt="" />
                        <span className="body-description">Property Keys</span>
                      </div>
                    </div>
                  </div>
                  <div className="p-6 bg-[#CECECE]/[15%] rounded-2xl">
                    <p className="text-[22px] font-medium">Delivery Options</p>
                    <div className="grid gap-y-3 mt-5">
                      <div className="flex items-center gap-x-5">
                        <img src="/assets/images/check-circle.svg" alt="" />
                        <span className="body-description">
                          DHL Express Delivery
                        </span>
                      </div>
                      <div className="flex items-center gap-x-5">
                        <img src="/assets/images/check-circle.svg" alt="" />
                        <span className="body-description">
                          Direct Pickup Available
                        </span>
                      </div>
                      <div className="flex items-center gap-x-5">
                        <img src="/assets/images/check-circle.svg" alt="" />
                        <span className="body-description">
                          Legal Team Support
                        </span>
                      </div>
                      <div className="flex items-center gap-x-5">
                        <img src="/assets/images/check-circle.svg" alt="" />
                        <span className="body-description">
                          5-7 Business Days
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="relative py-[58px] px-4 sm:px-10 lg:px-[175px] mt-[30px]">
        <img
          src="/assets/images/explore-bg.png"
          className="img-background"
          alt=""
        />
        <div className="lg:flex gap-x-[81px] items-center text-textWhite">
          <div className="flex-1">
            <h2 className="text-[36px] font-semibold">
              Your Next Home in Nigeria Awaits You, No Matter Where You Are
            </h2>
            <p className="mt-5 text-justify sm:text-left text-[16px]">
              Discover top properties and investment opportunities across
              Nigeria, tailored just for you. Whether you’re looking to buy, or
              invest, we've made it easy for you to find the perfect place - all
              from the comfort of your current location.
            </p>
          </div>
          <Link to="/property-search" className="mt-8 lg:mt-0 block">
            <button className="bg-white hover:bg-primary duration-300 mt-8 sm:mt-0 text-primary hover:text-textWhite px-[35px] py-3 text-[18px] uppercase font-semibold rounded-[10px]">
              Explore
            </button>
          </Link>
        </div>
      </section>
    </HomeLayout>
  );
};

export default HowItWorks;
